import { render, staticRenderFns } from "./ChooseRoute.vue?vue&type=template&id=0af22b0e&scoped=true&"
import script from "./ChooseRoute.vue?vue&type=script&lang=js&"
export * from "./ChooseRoute.vue?vue&type=script&lang=js&"
import style0 from "./ChooseRoute.vue?vue&type=style&index=0&id=0af22b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af22b0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VCard,VCardActions,VIcon,VResponsive})
